import React from 'react';
import { AuthPageContainer } from '../Register/AuthPageContainer';
import { AuthLogo } from './ClinicLogo';

/// Terminal screens - a dead, expired or blocked link. Nothing to retry.
export const RecordNotice = ({ notice, clinicLogoUrl }) => {
    return (
        <AuthPageContainer className={'recordAuth'} logo={<AuthLogo url={clinicLogoUrl} />} header={notice.title}>
            <div className={"recordNoticeText"}>{notice.message}</div>
        </AuthPageContainer>
    );
}
